export default {
    getMailCustomer: (state) => (id) => state.mailCustomer.find((mailCustomer) => mailCustomer.id === id),
    getMailCustomers: (state) => () => state.mailCustomer
}